// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  seasonion: false,
  appVersion: 'v1Balsam',
  USERDATA_KEY: 'authf649ei9a5f55',
  isMockEnabled: true,
  //apiUrl: 'http://77.232.99.142:8081/api',
  isMultiLanguageActive:true,
  themeDirectionStorageKey:"Balsam-Direction",
  defaultDirection:'rtl'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in seasonion mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
